import { FormLabel, Box } from '@mui/material';
import * as React from 'react';
import { Switcher } from './Switcher';

const SwitcherOption: React.FC<{
  children: React.ReactElement | React.ReactNode;
  enable?: boolean | null;
  onToggle?: (enable: boolean) => void;
}> = ({ children, enable, onToggle }) => {
  return (
    <>
      <FormLabel>{children}</FormLabel>
      <Box ml="auto">
        <Switcher enable={enable} onToggle={enable => onToggle?.(enable)} />
      </Box>
    </>
  );
};

export default SwitcherOption;
